export default __webpack_public_path__ + "static/media/mn.32f84418.svg";